import React, {useRef, useMemo, useState, useEffect} from "react";
import {PinturaEditor} from "react-pintura";
import {createDefaultImageReader, createDefaultImageWriter, getEditorDefaults} from "pintura";
import 'pintura/pintura.css';
import useTranslation from "../../virtual_congress/effects/use_translation";
import {urlToObjectUrl} from "../utils";

const DokaEditor = ({
                      photoBoothConfig,
                      imageBlob,
                      onFileEdited,
                      selectedFrame,
                      setSelectedFrame,
                      onResetClicked,
                      translationHtmlContent,
                    }) => {
  const [imageDecoration, setImageDecoration] = useState([])

  const t = useTranslation(translationHtmlContent)
  
  const editorConfig = useMemo(() => {
    return getEditorDefaults();
  }, [])

  const imageReader = useMemo(() => {
    return createDefaultImageReader()
  }, [])

  const imageWriter = useMemo(() => {
    return createDefaultImageWriter({
      targetSize: {
        width: photoBoothConfig.target_image_width,
        height: photoBoothConfig.target_image_height,
        upscale: true,
        fit: "cover"
      }
    })
  }, [photoBoothConfig.target_image_width, photoBoothConfig.target_image_height])

  const editorRef = useRef(null)

  const onImageProcessed = (event) => {
    onFileEdited(event.dest)
  }

  const pinturaEditor = useMemo(() => {
    return <PinturaEditor
      ref={editorRef}
      {...editorConfig}
      src={imageBlob}
      imageReader={imageReader}
      imageWriter={imageWriter}
      onProcess={onImageProcessed}
      enableToolbar={false}
      enableUtils={false}
      enableZoomControls={false}
      imageCropAspectRatio={photoBoothConfig.target_image_width / photoBoothConfig.target_image_height}
      imageDecoration={imageDecoration}
    />
  }, [editorRef, editorConfig, imageBlob, imageReader, imageWriter, onImageProcessed, imageDecoration, photoBoothConfig.target_image_width, photoBoothConfig.target_image_height])


  useEffect(() => {
    if (selectedFrame) {
      setImageDecoration([{
        backgroundSize: "force",
        width: "100%",
        height: "100%",
        backgroundImage: selectedFrame,
      }])
    } else {
      setImageDecoration([])
    }
  }, [selectedFrame])

  useEffect(() => {
    if (photoBoothConfig.force_border && photoBoothConfig.frames?.length > 0) {
      onFrameSelected(photoBoothConfig.frames[0])()
    }
  }, [])

  const showFrames = !photoBoothConfig.force_border || photoBoothConfig.frames?.length > 1

  const onClickDone = () => {
    const {editor} = editorRef.current;
    editor?.processImage()
  }

  const onFrameSelected = (frame) => {
    return () => {
      urlToObjectUrl(frame.url).then(url => {
        setSelectedFrame(url)
      })
    }
  }

  return <div className={"pictura-container"}>
    {pinturaEditor}
    {showFrames && 
      <div className={"frame-container"}>
        {photoBoothConfig.frames.map(frame => {
          return <button
            key={frame.id}
            className={"frame-button asset-button"}
            type={"button"}
            onClick={onFrameSelected(frame)}>
            <img
              style={{width: "9vmin"}}
              src={frame.url}/>
          </button>
        })}
      </div>
  }

    <div className="button-container">
      <button className={"photo-booth-button finished-button"} type={"button"} onClick={onResetClicked}>
        {t("photo_booth.doka.reset_button_html", {}, "Reset")}
      </button>
      <button className={"photo-booth-button finished-button"} type={"button"} onClick={onClickDone}>
        {t("photo_booth.doka.continue_button_html", {}, "Done")}
      </button>
    </div>
  </div>
}

export default DokaEditor